import gsap from 'gsap';

export default function initStats() {
    const statsElements = document.querySelectorAll('.stats');
    const cleanups = [];

    statsElements.forEach((stats) => {
        const items = stats.querySelectorAll('.stats__content__item');
        const images = stats.querySelectorAll('.stats__images__item');
        const progressBars = stats.querySelectorAll('.stats__progress__bar');

        let currentIndex = 0;
        const duration = 7; // seconds
        let timeline;
        let observer;
        let isStarted = false;

        function playNext() {
            // Clear previous active states
            items.forEach(item => item.classList.remove('active'));
            if (images.length) {
                images.forEach(img => img.classList.remove('active'));
            }

            // Update index
            currentIndex = (currentIndex + 1) % items.length;

            // Start animation for new index
            startAnimation();
        }

        function startAnimation() {
            if (timeline) timeline.kill();

            // Set active classes
            items[currentIndex].classList.add('active');
            if (images.length && images[currentIndex]) {
                images[currentIndex].classList.add('active');
            }

            // Reset all progress bars
            gsap.set(progressBars, { scaleX: 0, transformOrigin: 'left' });

            // Animate current progress bar
            timeline = gsap.to(progressBars[currentIndex], {
                scaleX: 1,
                duration: duration,
                ease: 'none',
                onComplete: playNext
            });
            isStarted = true;
        }

        // Pause/Resume based on visibility
        observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!isStarted) {
                        // Initialize first state only when it becomes visible for the first time
                        startAnimation();
                    } else if (timeline) {
                        timeline.resume();
                    }
                } else {
                    if (timeline) {
                        timeline.pause();
                    }
                }
            });
        }, { threshold: 0.1 });

        observer.observe(stats);

        cleanups.push(() => {
            if (timeline) timeline.kill();
            if (observer) observer.disconnect();
        });
    });

    return () => {
        cleanups.forEach(cleanup => cleanup());
    };
}
